// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable prefer-const, react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */

import React, { useCallback } from "react";
import { AnyFilter } from "./types";

/**
 * Creates a memoized callback for filtering rows by matching string values on a data property.
 * Used with SearchPanel.MultiDropdown to filter SearchPanel results by string columns.
 *
 * @param prop - The data property name to filter on (e.g. "cropId").
 * @param setFilters - State setter for the filters object.
 * @param header - Optional secondary filter key used as an "indicator" entry (e.g. "cropName"
 *   alongside "cropId") so the results table can show a filter-active icon on the display column.
 * @param showNulls - When true, rows with null values for the property are included in results.
 */
export const generateStringFilter = (
	prop: string,
	setFilters: React.Dispatch<React.SetStateAction<{ [key: string]: AnyFilter }>>,
	header?: string,
	showNulls: boolean = false,
) =>
	useCallback((filter: string[], applied: boolean) => {
		if (header) {
			setFilters((prev) => ({
				...prev,
				[header]: { type: "indicator", applied, showNulls },
				[prop]: { type: "string", names: filter, applied, showNulls },
			}));
		} else {
			setFilters((prev) => ({ ...prev, [prop]: { type: "string", names: filter, applied, showNulls } }));
		}
	}, []);

/**
 * Creates a memoized callback for filtering rows by matching boolean values on a data property.
 * Used with SearchPanel.MultiDropdown to filter SearchPanel results by boolean columns.
 *
 * @param prop - The data property name to filter on (e.g. "fieldScaleTrial").
 * @param setFilters - State setter for the filters object.
 * @param valueMap - Maps dropdown option string values to booleans
 *   (e.g. `{ "field-scale": true, "small-plot": false }`).
 */
export const generateBooleanFilter = (
	prop: string,
	setFilters: React.Dispatch<React.SetStateAction<{ [key: string]: AnyFilter }>>,
	valueMap: Record<string, boolean>,
) =>
	useCallback((filter: string[], applied: boolean) => {
		const values = filter.map((key) => valueMap[key]);
		setFilters((prev) => ({ ...prev, [prop]: { type: "boolean", values, applied } }));
	}, []);

export const iconColorMap = {
	grey: "var(--neutral-600)",
	green: "var(--primary-clover-600)",
	yellow: "var(--secondary-amber-500)",
	red: "var(--accent-negative-UI-600)",
};

export const getDefaultGrowingSeasons = () => {
	let defaults = [
		"Perennial Multi-Year",
		"2026 Perennial",
		"2026 Spring Annual",
		"2025 Fall Annual",
		"2025 Southern Hemisphere Spring",
	];

	return defaults;
};
